export default "__VITE_ASSET__Bc1Z3MYB__"